import Page from "../../components/Page";
import ComplianceReportSectionAgentDetail from "../../components/Reports/complianceReport/ComplianceReportSectionAgentDetail";
import ComplianceReportSectionDetail from "../../components/Reports/complianceReport/ComplianceReportSectionDetail";

export const ComplianceReportAgentDetailPage = () => {
    return (
        <Page>
            <ComplianceReportSectionAgentDetail
                isMobile={false}
            />
        </Page>
    );
};

export default ComplianceReportAgentDetailPage;
